// extracted by mini-css-extract-plugin
export default {"styleChooserSection":"O3-z","dimensionLabel":"P3-z","styleChooserControlWrapper":"Q3-z","styleChooserControl":"R3-z","disabled":"S3-z","giftCard":"T3-z","styleChooserText":"U3-z"};